import React, { useEffect, useRef } from 'react'
import styled from 'styled-components';
import StarborderOutlinedIcon from '@material-ui/icons/StarBorderOutlined'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import ChatInput from './ChatInput';
import { useSelector } from 'react-redux';
import { selectRoomId } from '../features/appSlice';
import { useCollection, useDocument } from 'react-firebase-hooks/firestore';
import { db } from '../firebase';
import Message from './Message';


function Chat() {

    const chatrRef = useRef(null);

    const roomId = useSelector(selectRoomId);

    const [roomDetails] = useDocument(
        roomId && db.collection('rooms').doc(roomId)  //fetching room detals

    )

    const [roomMessage, loading] = useCollection(
        roomId &&
        db.collection('rooms').doc(roomId).collection('messages').orderBy("timestamp", "asc")
    )


    useEffect(() => {
        chatrRef?.current?.scrollIntoView({
            behavior: "smooth",
        });
    }, [roomId, loading])


    //console.log(roomDetails?.data());
    //console.log(roomMessage);

    return (
        <Chatcontainer>

            {roomDetails && roomMessage && (
                <>
                    <Header>
                        <HeaderLeft>
                            <h4>
                                <strong>#{roomDetails?.data().name}</strong>
                            </h4>

                            <StarborderOutlinedIcon />

                        </HeaderLeft>

                        <HeaderRight>
                            <p>
                                <InfoOutlinedIcon /> Details
                    </p>
                        </HeaderRight>
                    </Header>

                    <ChatMessege>
                        {roomMessage?.docs.map((doc) => {
                            const { message, timestamp, user, userImage } = doc.data();

                            return (
                                <Message
                                    key={doc.id}
                                    message={message}
                                    timestamp={timestamp}
                                    user={user}
                                    userImage={userImage}

                                />
                            )
                        })}

                    </ChatMessege>
                    <ChatBottom ref={chatrRef} />

                    <ChatInput
                        chatrRef={chatrRef}
                        channelName={roomDetails?.data().name}
                        channelId={roomId}
                    />
                </>

            )}

        </Chatcontainer>
    )
}
export default Chat;

const ChatMessege = styled.div`
`;

const ChatBottom = styled.div`
    padding-bottom:200px;
`;

const Header = styled.div`
    display:flex;
    justify-content:space-between;
    padding:20px;
    border-bottom: 1px solid lightgray;

`;
const HeaderLeft = styled.div`
    display:flex;
    align-items:center;
>h4 {
    display:flex;
    text-transform:lowercase;
    margin-right:10px;

}
>h4 > .MuiSvgIcon-root {
    margin-left:10px;
    font-size:18px;
}

`;
const HeaderRight = styled.div`
>p {
        display:flex;
        align-items:center;
        font-size:14px;

    }

>p > .MuiSvgIcon-root {
    margin-right:5px !important;
    font-size:16px;
} 
`;

const Chatcontainer = styled.div`
    flex:0.7;
    flex-grow:1;
    overflow-y:scroll;
    margin-top:55px;
    
`;